module.exports = __webpack_public_path__ + "img/backgroundAdvertisement.9a71fe29.png";